import type { ReactElement } from 'react';
import type IAiChatDisplayPlaceholder from '../../interfaces/IAiChatDisplayPlaceholder';

import styles from '../../sass/AiChat.module.scss';

/**
 * The slot of a display tool before its output is in: the title over nothing, and beside it what
 * the call is doing. Every display tool opens with this, so a table and a chart arrive the same way.
 */
function AiChatDisplayPlaceholder({ title, status, errorText }: IAiChatDisplayPlaceholder): ReactElement {
  return (
    <div className={styles.datasource}>
      <div className={styles.toolHeader}>
        <p className={styles.datasourceTitle}>{title}</p>
        {status ? <p className={styles.toolStatus}>{status}</p> : null}
      </div>
      {errorText ? <div className={styles.toolError}>{errorText}</div> : null}
    </div>
  );
}

export default AiChatDisplayPlaceholder;
